import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import "@mdi/font/css/materialdesignicons.min.css"

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    theme: {
        themes: {
            light: {
                primary: "#28a745",
                secondary: "#008d4c", // #FFCDD2
                accent: "#3F51B5", // #3F51B5
                success: '#28a745',
                background: '#f2f2f2',
            },
            dark: {
                primary: "#28a745",
                secondary: "#008d4c", // #FFCDD2
                accent: "#3F51B5", // #3F51B5
                success: '#28a745',
                background: '#121212',
            },
        },
        dark: localStorage.getItem('app-theme')
    },
});
